// extracted by mini-css-extract-plugin
export var blink = "_64-2";
export var cursor = "_64-1";
export var reactMarkdown = "_64-3";
export var streamingText = "_64-0";